import { FLAGS } from 'FeatureFlagsConfig';
import { parseFlagValue } from 'Utils/features';
import AbstractFeatureFlagProvider from './AbstractFeatureFlagProvider';

export default class LocalStorageFeatureFlagProvider extends AbstractFeatureFlagProvider {
  constructor(priority) {
    super('LOCAL_STORAGE_FF', priority);
  }

  async getFeatureFlags() {
    const setFeature = (name) => {
      const value = localStorage.getItem(name);

      if (value !== null) {
        this.features.set(name, parseFlagValue(value));
      }
    };

    Object.keys(FLAGS).forEach(setFeature);
  }
}
